import { render, staticRenderFns } from "./ConcurrentLabelBox.vue?vue&type=template&id=3cd23f5a&scoped=true&"
import script from "./ConcurrentLabelBox.vue?vue&type=script&lang=js&"
export * from "./ConcurrentLabelBox.vue?vue&type=script&lang=js&"
import style0 from "./ConcurrentLabelBox.vue?vue&type=style&index=0&id=3cd23f5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd23f5a",
  null
  
)

export default component.exports